import React, { FC, useRef, useState } from "react";
import { Swiper, SwiperClass, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import FormApplicationFast from "./FormApplicationFast";
import FormApplicationDopInfo from "./FormApplicationDopInfo";
import FormApplicationProgram from "./FormApplicationProgram";
import { ApplyOnlineDocSvg } from "@/src/svg/ApplyOnlineDocSvg";
import FormSummaryModal from "../../FormSummaryModal/FormSummaryModal";
import { FileFieldName, IApplyOnline, IFormApplicationProps } from "@/src/types/IApplyOnline";
import { UseFormSetValue } from "react-hook-form";

interface Props extends IFormApplicationProps {
  handleFocus: (el: string) => void;
  handleClickDocument: (action: "open" | "close") => void;
  fileModalIsActive: boolean;
}

const FormApplicationMobile: FC<Props> = ({
  register,
  control,
  errors,
  selectedFilesMap,
  setSelectedFilesMap,
  isSubmitDisabled,
  handleSubmit,
  handleFocus,
  handleClickDocument,
  fileModalIsActive,
  setValue,
}) => {
  const prevRef = useRef<HTMLButtonElement>(null);
  const nextRef = useRef<HTMLButtonElement>(null);

  const handleSlideChange = (swiper: SwiperClass) => {
    switch (swiper.activeIndex) {
      case 0:
        handleFocus("one");
        break;
      case 1:
        handleFocus("two");
        break;
      case 2:
        handleFocus("three");
        break;
    }
  };

  return (
    <div className="form-application-slider">
      <Swiper
        modules={[Navigation]}
        spaceBetween={20}
        slidesPerView={1}
        navigation={{
          prevEl: prevRef.current!,
          nextEl: nextRef.current!,
        }}
        onBeforeInit={(swiper: SwiperClass) => {
          if (typeof swiper.params.navigation !== "boolean" && swiper.params.navigation) {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
          }
        }}
        loop={false}
        onSlideChange={handleSlideChange}
        allowTouchMove={false}
        simulateTouch={false}
      >
        <SwiperSlide>
          <FormApplicationFast register={register} control={control} errors={errors} />
        </SwiperSlide>
        <SwiperSlide>
          <FormApplicationDopInfo register={register} control={control} errors={errors} />
        </SwiperSlide>
        <SwiperSlide>
          <FormApplicationProgram register={register} control={control} errors={errors} />
          <div className="form-application-document-btn" onClick={() => handleClickDocument("open")}>
            <span>Вложение файла</span>
            <ApplyOnlineDocSvg />
          </div>
          <div className="form-application-document-quantity">
            <span>Attached: </span>
            <span>{selectedFilesMap ? Object.values(selectedFilesMap).flat().length : "0"} files</span>
          </div>
        </SwiperSlide>
        <div className="form-application-fixed-btns">
          <div className="form-application-slider-btns">
            <button className="form-application-slider-btn prev" ref={prevRef}>
              ← Предыдущий
            </button>
            <button
              className={`form-application-slider-btn next ${isSubmitDisabled ? "disabled" : ""}`}
              ref={nextRef}
              disabled={isSubmitDisabled}
            >
              Следующий →
            </button>
          </div>

          <button
            className={`form-application-submit-btn ${isSubmitDisabled ? "disabled" : ""}`}
            disabled={isSubmitDisabled}
            type="button"
            onClick={handleSubmit}
          >
            Отправить
          </button>
        </div>
      </Swiper>

      <FormSummaryModal
        isActive={fileModalIsActive}
        onClose={() => handleClickDocument("close")}
        register={register}
        setValue={setValue as UseFormSetValue<IApplyOnline>}
        selectedFilesMap={selectedFilesMap as Record<FileFieldName, File[]>}
        setSelectedFilesMap={setSelectedFilesMap as React.Dispatch<React.SetStateAction<Record<FileFieldName, File[]>>>}
      />
    </div>
  );
};

export default FormApplicationMobile;
